import { render } from "./HolderAnalytics.vue?vue&type=template&id=f74322c2&scoped=true"
import script from "./HolderAnalytics.vue?vue&type=script&lang=js"
export * from "./HolderAnalytics.vue?vue&type=script&lang=js"

import "./HolderAnalytics.vue?vue&type=style&index=0&id=f74322c2&scoped=true&lang=css"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f74322c2"],['__file',"resources/js/components/HolderAnalytics.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f74322c2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f74322c2', __exports__)) {
    api.reload('f74322c2', __exports__)
  }
  
  module.hot.accept("./HolderAnalytics.vue?vue&type=template&id=f74322c2&scoped=true", () => {
    api.rerender('f74322c2', render)
  })

}


export default __exports__